// Ordem obrigatória daqui até o último `import './styles/...'`: csp-init antes de tudo, e as
// folhas sem layer na sequência abaixo (styles.scss primeiro, dark por último). Não reordenar.
import './csp-init';
import '@/config/dayjs';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { HashRouter } from 'react-router';

import { ColorModeProvider } from '@/contexts/colorMode';
import { i18nReady } from '@/assets/i18n';

import Index from './views/base/Index';

import './styles/styles.scss';

import '@datanomik/core-ui/styles.css';
import './styles/tailwind.css';

import './styles/fonts.css';
import './styles/darkModeOverrides.css';

const container = document.getElementById('root');
const root = createRoot(container);

i18nReady.finally(() => root.render(
  <HashRouter>
    <ColorModeProvider>
      <Index />
    </ColorModeProvider>
  </HashRouter>,
));
